module.exports = ".welcome{\r\n  text-align: center;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/welcome/welcome.component.css
// module id = ./src/app/welcome/welcome.component.css
// module chunks = main